import { useState } from 'react';
import { tagCloud } from '@/mocks/home';

export default function TagCloud() {
  const [activeTag, setActiveTag] = useState('校园片');

  return (
    <section className="bg-background-100 py-10 md:py-14 border-t border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">大家都在搜</h2>
          </div>
          <span className="text-xs md:text-sm text-foreground-500">共 120 个热门标签 · 点击快速筛选</span>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-2.5">
          {tagCloud.map((tag) => {
            const isActive = activeTag === tag;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActiveTag(tag)}
                className={`text-sm px-3.5 py-2 rounded-full border transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 border-primary-500 text-background-50'
                    : 'bg-background-50 border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}